import { observer } from 'mobx-react-lite'
import React from 'react'
import { Dimensions, Image, useWindowDimensions, View } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

import FirstGameBotsBubbleImage from '../../../assets/MyFirstGame/first-game-bots-bubble.png'
// import Banner from '../../../assets/MyFirstGameBanner.svg'
import { DS } from '../../design-system'
import { useStore } from '../../models'
import { events } from '@/models/analytics/analytics-events'

const FirstGameWelcomeScreen = observer(() => {
  const insets = useSafeAreaInsets()
  const { width } = useWindowDimensions()

  const {
    game: { goToNextFirstGameStep, setIsMyFirstGame, resetFirstGame },
    analytics: { setEvent }
  } = useStore()

  const proceedToPlay = async () => {
    try {
      setEvent(events.gamescreen.lets_play_button_tapped)
      resetFirstGame()
      setIsMyFirstGame(true)
      goToNextFirstGameStep()
    } catch (error) {
      console.log('proceedToPlay error', error)
    }
  }

  return (
    <DS.Frame style={{ flex: 1, padding: 16 }}>
      <DS.Frame style={{ position: 'absolute', top: -25 }}>
        {/* <Banner width={width} height={195} preserveAspectRatio="xMidYMid meet" /> */}
        <View style={{ width, height: 195 }} />
      </DS.Frame>
      <DS.Frame
        style={{ flex: 1, justifyContent: 'center', alignItems: 'center', gap: 8, marginBottom: insets.bottom }}
      >
        <DS.Text variant={'Heading 1/Medium'} color={'Global/White'} style={{ textAlign: 'center' }}>
          Let’s walk through your
        </DS.Text>
        <DS.Text variant={'Heading 1/Medium'} color={'Global/White'} style={{ textAlign: 'center' }}>
          first{' '}
          <DS.Text variant={'Heading 1/Medium'} color={'Brand/Pink'}>
            poker game
          </DS.Text>
        </DS.Text>
        <Image source={FirstGameBotsBubbleImage} style={{ width: 144, height: 48 }} resizeMode={'contain'} />
        <DS.Frame>
          <DS.Frame style={{ flexDirection: 'row', gap: 2 }}>
            <DS.Frame
              style={{
                paddingHorizontal: 8,
                paddingVertical: 4,
                borderRadius: 12,
                borderTopRightRadius: 2,
                backgroundColor: '#822852',
                alignSelf: 'flex-start'
              }}
            >
              <DS.Text variant={'Mini/Bold'} color={'Global/White'}>
                HEY!
              </DS.Text>
            </DS.Frame>
            <DS.Frame
              style={{
                paddingHorizontal: 8,
                paddingVertical: 4,
                borderRadius: 12,
                borderTopLeftRadius: 2,
                backgroundColor: '#822852'
              }}
            >
              <DS.Text variant={'Mini/Bold'} color={'Global/White'}>
                WE'RE BOTS{'\n'}PLAYING WITH{'\n'}YOU TODAY!
              </DS.Text>
            </DS.Frame>
          </DS.Frame>
        </DS.Frame>
      </DS.Frame>
      <DS.Button variant={'Large/Primary'} type={'On Dark'} style={{ marginBottom: 16 }} onPress={proceedToPlay}>
        Let’s play
      </DS.Button>
    </DS.Frame>
  )
})

export default FirstGameWelcomeScreen
